export const UMB_LANGUAGE_ROOT_WORKSPACE_ALIAS = 'Umb.Workspace.LanguageRoot';
export * from './paths.js';
